/* eslint-disable */
import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/Start.vue'
import Recipe from '../views/Details.vue'
import RecipeForm from '../views/RecipeForm.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/recipe/new',
    name: 'NewRecipe',
    component: RecipeForm,
  },
  {
    path: '/recipe/:id/edit',
    name: 'EditRecipe',
    component: RecipeForm,
  },
  {
    path: '/recipe/:id',
    name: 'Recipe',
    component: Recipe,
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
